var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-icon",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4053233,4 C20.286093,4 21,4.70764594 21,5.5803049 L21,5.5803049 L21,9.29388051 L13.7831873,9.29388051 C12.2858472,9.29388051 11.0719841,10.4965655 11.0719841,11.980117 C11.0719841,13.4639817 12.2858472,14.6666667 13.7831873,14.6666667 L13.7831873,14.6666667 L21,14.6666667 L21,18.4196951 C21,19.2923541 20.286093,20 19.4053233,20 L19.4053233,20 L4.59499271,20 C3.71422301,20 3,19.2923541 3,18.4196951 L3,18.4196951 L3,5.5803049 C3,4.70764594 3.71422301,4 4.59499271,4 L4.59499271,4 Z M13.7830293,10.6986534 C14.5320154,10.6986534 15.1387889,11.3057429 15.1387889,12.054413 C15.1387889,12.803083 14.5320154,13.4101726 13.7830293,13.4101726 C13.0343593,13.4101726 12.4275857,12.803083 12.4275857,12.054413 C12.4275857,11.3057429 13.0343593,10.6986534 13.7830293,10.6986534 Z",
    id: "Combined-Shape"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.a411465ab20c87e77439836ba7e93696.svg";
export { ForwardRef as ReactComponent };